/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CroppedAsset as CroppedAssetModel } from 'models';

import CroppedAsset from 'kentico-blocks/CroppedAsset';
import styled from 'styled-components';
import root from 'window-or-global';
import { Bind } from 'lodash-decorators';
import { inject, observer } from 'mobx-react';
import ds, { media } from 'designsystem';
import DesksImage from './DesksImage';
import ImageWrapper from './ImageWrapper';
import HandImage from './HandImage';

const FloatingComponents = styled.div`
  position: relative;
  transition: transform 0.55s ease-in-out;
  width: 100%;
  max-width: 300px;
  left: ${ds.get('metrics.s')};

  ${media.tablet`
    max-width: 360px;
  `}

  ${media.desktop`
    margin-top: ${ds.get('metrics.xl')}
    max-width: 540px;
    top: 5%;
  `}
`;

const CroppedAssets = styled.div`
  position: absolute;
  top: 0;
  transform: translateY(-35px) scale(0.51);

  ${media.tablet`
    transform: translateY(-50px) scale(0.62);
  `}

  ${media.desktop`
    transform: scale(1);
    top: -${ds.get('metrics.xl')}
    left: -10px;
  `}
`;

@inject('windowStore')
@observer
class ImageBlock extends Component {
  constructor(props) {
    super(props);
    this.floatingComponentsRef = React.createRef();
  }

  componentDidMount() {
    root.addEventListener('scroll', this.setScrollY);
  }

  componentWillUnmount() {
    root.removeEventListener('scroll', this.setScrollY);
  }

  @Bind
  setScrollY() {
    this.floatingComponentsRef.current.style.transform = `translateY(${root.scrollY}px)`;
  }

  render() {
    const {
      backgroundDesks,
      backgroundHand,
      floatingElements,
      windowStore,
    } = this.props;

    return (
      <ImageWrapper>
        <DesksImage
          src={windowStore.adjustImageSize(backgroundDesks)}
        />
        <FloatingComponents innerRef={this.floatingComponentsRef}>
          <HandImage
            src={windowStore.adjustImageSize(backgroundHand)}
          />
          <CroppedAssets>
            {floatingElements.map(element => (
              <CroppedAsset
                data={element}
                absolute
                key={element.id}
              />
            ))}
          </CroppedAssets>
        </FloatingComponents>
      </ImageWrapper>
    );
  }
}
ImageBlock.propTypes = {
  backgroundDesks: PropTypes.string.isRequired,
  backgroundHand: PropTypes.string.isRequired,
  floatingElements: PropTypes.arrayOf(PropTypes.instanceOf(CroppedAssetModel)),
};
ImageBlock.defaultProps = {
  floatingElements: [],
};

export default ImageBlock;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/ImageBlock/index.jsx